import styled from "styled-components";
import {AuditStatusID} from "../Models/Audit/AuditConstants";

export const AuditsPage = styled.div`
    & .auditsCreated .MuiSvgIcon-root {
        color: #DD7CC2;
    }

    & .auditsCompleted .MuiSvgIcon-root {
        color: #4CA2A8;
    }

    & .auditsInReview .MuiSvgIcon-root {
        color: #E6B056;
    }

    & .auditsRequestEdits .MuiSvgIcon-root {
        color: #f85151;
    }

    & .auditsUnknownStatus .MuiSvgIcon-root {
        color: #333639;
    }

    & .MuiTab-root {
        text-transform: none;
    }

    & .MuiTabs-indicator {
        background: ${({theme}) => theme.color.dark} !important;
    }
`;

export function getAuditStatusBackgroundColor(statusID) {
    switch (statusID) {
        case AuditStatusID.IN_PROGRESS:
            return "#DD7CC2";
        case AuditStatusID.COMPLETED:
            return "#4CA2A8";
        case AuditStatusID.IN_REVIEW:
            return "#E6B056";
        case AuditStatusID.EDITS_REQUIRED:
            return "#f85151";
    }
}

